import React from "react";
import { Component } from "react";
import "./TermsScreen.scss";
import downloadIcon from  "../../../content/cloud-arrow-down.svg";

export default class TermsScreen extends Component {
  readonly privacyPolicyUrl =
    "https://storage.googleapis.com/mediti-static/terms/pl/PrivacyPolicy01012024.pdf";
  readonly oldPrivacyPolicyUrl =
    "https://storage.googleapis.com/mediti-static/terms/pl/PrivacyPolicy01012024_old.pdf";
  readonly termsUrl =
    "https://storage.googleapis.com/mediti-static/terms/pl/TermsAndConditions01012024.pdf";
  readonly oldTermsUrl =
    "https://storage.googleapis.com/mediti-static/terms/pl/TermsAndConditions01012024_old.pdf";

  public render() {
    return (
      <div className="terms-container">
        <div className="terms-header">
          <div className="row">
            <div className="col">
              <h1 className="title">Regulaminy</h1>
              <p className="desc">Możesz <span className="gold-text">pobrać</span> regulaminy w formie PDF.</p>
            </div>
          </div>
        </div>

        <div className="terms-body">
          <div className="terms-actual">
            <h2>Obowiązujące dokumenty</h2>
            <ul>
              <li>
                <a href={this.termsUrl}>
                  <img className="download-icon" src={downloadIcon} alt="download icon" />
                  Regulamin świadczenia usług
                </a>
              </li>
              <li>
                <a href={this.privacyPolicyUrl}>
                  <img className="download-icon" src={downloadIcon} alt="download icon" />
                  Polityka prywatności
                </a>
              </li>
            </ul>
          </div>

          <div className="terms-old">
            <h2>Archiwalne wersje dokumentów</h2>
            <ul>
              <li>
                <a href={this.oldTermsUrl}>
                  <img className="download-icon" src={downloadIcon} alt="download icon" />
                  Regulamin świadczenia usług (do 01.01.2024)
                </a>
              </li>
              <li>
                <a href={this.oldPrivacyPolicyUrl}>
                  <i className="bi bi-cloud-arrow-down"></i>
                  <img className="download-icon" src={downloadIcon} alt="download icon" />
                  Polityka prywatności (do 01.01.2024)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
